﻿import { autorun } from "mobx";
import XYZSource from "ol/source/XYZ";
import { IChartConfig } from "../../models/ChartModels";
import { ChartStates } from "../../models/ChartStates";
import { MobxReactionDisposer } from "../../models/MobxReactionDisposer";

class MsgBaseSource extends XYZSource {

    protected mobxDisposer = new MobxReactionDisposer();

    constructor(
        config: IChartConfig,
        private states: ChartStates) {

        super(config.chartLayer);

        const baseUrl = config.chartLayer?.url;

        this.mobxDisposer.add([
            autorun(() => {
                const token = this.states.token.token;
                if (token && baseUrl) {
                    const type = this.states.chart.layerDetailLevel ?? 'low';
                    const url = baseUrl
                        .replace("{type}", type)
                        .replace("{token}", token);
                    this.setUrl(url);
                }
                else {
                    this.setUrl('');
                }
                this.changed();
            })
        ])
    }

    public dispose() {
        this.mobxDisposer.clear();
        super.dispose();
    }
}

export default MsgBaseSource;